import { render, staticRenderFns } from "./TheControlsEditPage.vue?vue&type=template&id=0230da8b"
import script from "./TheControlsEditPage.vue?vue&type=script&lang=js"
export * from "./TheControlsEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports